import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-dismiss after 5 seconds
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  disconnect() {
    // Clear timeout if element is removed before timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Add fade-out animation
    this.element.style.transition = "opacity 300ms ease-out, transform 300ms ease-out"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-10px)"
    
    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
